import { Host, h } from "@stencil/core";
export class ApieConstraintCheckDefinition {
    constructor() {
        this.value = undefined;
        this.message = undefined;
        this.inverseCheck = false;
        this.exactMatch = undefined;
        this.pattern = undefined;
        this.minLength = undefined;
        this.maxLength = undefined;
        this.status = 'idle';
    }
    get constraint() {
        return {
            fieldType: 'constraint',
            message: this.message,
            inverseCheck: this.inverseCheck,
            exactMatch: this.exactMatch === undefined ? this.value : this.exactMatch,
            pattern: this.pattern,
            serverSide: this.exactMatch !== undefined,
            minLength: this.minLength,
            maxLength: this.maxLength,
        };
    }
    async getDefinition() {
        this.status = 'built';
        return Promise.resolve(this.constraint);
    }
    render() {
        return (h(Host, { key: '8c6dcdf2c0294d9e4560c27b221a09789b5b5310' }, h("slot", { key: 'e1cb815c64e90bb1e7a83cdfb1e04c1b82e7e5ba' })));
    }
    static get is() { return "apie-constraint-check-definition"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-constraint-check-definition.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-constraint-check-definition.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "value",
                "reflect": true
            },
            "message": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "message",
                "reflect": false
            },
            "inverseCheck": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "inverse-check",
                "reflect": false,
                "defaultValue": "false"
            },
            "exactMatch": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "string|number|null|undefined",
                    "resolved": "number | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "exact-match",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "pattern": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "pattern",
                "reflect": false
            },
            "minLength": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "min-length",
                "reflect": false
            },
            "maxLength": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "max-length",
                "reflect": false
            },
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "status",
                "reflect": true,
                "defaultValue": "'idle'"
            }
        };
    }
    static get methods() {
        return {
            "getDefinition": {
                "complexType": {
                    "signature": "() => Promise<Constraint>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "Constraint": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::Constraint"
                        }
                    },
                    "return": "Promise<Constraint>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=apie-constraint-check-definition.js.map
